import React from 'react';
import { useGrades } from 'hooks';
import { FormControlLabel, Checkbox } from '@mui/material';
import { setNestedObjectValues } from 'formik';

const CheckboxSelector = ({ filter, graduating, value, setValue, error }) => {
    const [state, actions] = useGrades();

    if (!state.loaded) {
        actions.load();
    }

    let gradeOptions = [...state.grades, ...(graduating ? [{ label: 'Graduating', value: -2 }] : [])];
    if (!filter) {
        gradeOptions.shift();
    }

    const handleCheck = (checkValue, e) => {
        const isChecked = e.target.checked;
        if (checkValue === -1) {
            setValue([-1]);
        } else if (isChecked) {
            setValue([...value, checkValue].filter((grade) => grade !== -1).sort((a, b) => (a < b ? -1 : 1)));
        } else {
            const newValue = value.filter((grade) => grade !== checkValue);
            if (newValue.length === 0) {
                setValue([-1]);
            } else {
                setValue(newValue.sort((a, b) => (a < b ? -1 : 1)));
            }
        }
    };

    return gradeOptions.map((grade) => {
        return (
            <FormControlLabel
                label={grade.label}
                key={grade.value}
                control={
                    <Checkbox
                        onChange={(e) => handleCheck(grade.value, e)}
                        checked={value.indexOf(grade.value) > -1}
                    ></Checkbox>
                }
            ></FormControlLabel>
        );
    });
};

export default CheckboxSelector;
